import { createContext } from 'react';

import * as Types from '../types';

export const Context = createContext<Types.IContext.Value | null>(null);
